import { Box, Grid, Paper } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { PreviewDomesticOrderQuery } from "@saleor/graphql";
import { maybe } from "@saleor/misc";
import classNames from "classnames";
import React, { FC } from "react";
import { useIntl } from "react-intl";

import useStyle from "./styles";
export interface PreviewNotRefHeaderProps {
  previewOrder?: PreviewDomesticOrderQuery;
}

const PreviewOrderNotRefHeader: FC<PreviewNotRefHeaderProps> = ({
  previewOrder
}) => {
  const classes = useStyle();
  const intl = useIntl();

  return (
    <Paper className={classes.header}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Box className={classes.headerItem}>
            <MyTypography
              variant="subtitle3"
              className={classNames(classes.headerTitle, classes.center)}
            >
              {intl.formatMessage({
                defaultMessage: "เลขที่ใบสั่งซื้อ"
              })}
            </MyTypography>
            <MyTypography variant="subtitle1" className={classes.mainColor}>
              {previewOrder?.previewDomesticOrder?.previewHeaderData?.soNo}
            </MyTypography>
          </Box>
          <Box className={classes.headerItem}>
            <MyTypography variant="subtitle3" className={classes.headerTitle}>
              {intl.formatMessage({
                defaultMessage: "เลขที่ PO ลูกค้า"
              })}
            </MyTypography>
            <MyTypography variant="body3">
              {previewOrder?.previewDomesticOrder?.previewHeaderData?.poNumber}
            </MyTypography>
          </Box>
          <Box className={classes.headerItem}>
            <MyTypography variant="subtitle3" className={classes.headerTitle}>
              {intl.formatMessage({
                defaultMessage: "วันที่สร้างใบสั่งซื้อ"
              })}
            </MyTypography>
            <MyTypography variant="body3">
              {maybe(
                () =>
                  previewOrder?.previewDomesticOrder?.previewHeaderData
                    ?.orderDate
              )}
            </MyTypography>
          </Box>
          <Box className={classes.headerItem}>
            <MyTypography variant="subtitle3" className={classes.headerTitle}>
              {intl.formatMessage({
                defaultMessage: "เงื่อนไขการชำระเงิน"
              })}
            </MyTypography>
            <MyTypography variant="body3">
              {
                previewOrder?.previewDomesticOrder?.previewHeaderData
                  ?.paymentTerm
              }
            </MyTypography>
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box className={classes.headerItem}>
            <MyTypography variant="subtitle3" className={classes.headerTitle}>
              {intl.formatMessage({
                defaultMessage: "ชื่อลูกค้า"
              })}
            </MyTypography>
            <MyTypography variant="body3">
              {
                previewOrder?.previewDomesticOrder?.previewHeaderData
                  ?.customerName
              }
            </MyTypography>
          </Box>
          <Box className={classes.headerItem}>
            <MyTypography variant="subtitle3" className={classes.headerTitle}>
              {intl.formatMessage({
                defaultMessage: "Sales Org"
              })}
            </MyTypography>
            <MyTypography variant="body3">
              {
                previewOrder?.previewDomesticOrder?.previewHeaderData
                  ?.saleOrganization
              }
            </MyTypography>
          </Box>
          <Box className={classes.headerItem}>
            <MyTypography variant="subtitle3" className={classes.headerTitle}>
              {intl.formatMessage({
                defaultMessage: "Sales Employee"
              })}
            </MyTypography>
            <MyTypography variant="body3">
              {previewOrder?.previewDomesticOrder?.previewHeaderData
                ?.saleEmployee
                ? previewOrder?.previewDomesticOrder?.previewHeaderData
                    ?.saleEmployee
                : "10488 - test"}
            </MyTypography>
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box className={classes.headerItem}>
            <MyTypography variant="subtitle3" className={classes.headerTitle}>
              {intl.formatMessage({
                defaultMessage: "Bill-to Party"
              })}
            </MyTypography>
            <MyTypography
              variant="body3"
              style={{
                whiteSpace: "pre-line"
              }}
            >
              {previewOrder?.previewDomesticOrder?.previewHeaderData?.billTo}
            </MyTypography>
          </Box>
          <Box className={classes.headerItem}>
            <MyTypography variant="subtitle3" className={classes.headerTitle}>
              {intl.formatMessage({
                defaultMessage: "Ship-to Party"
              })}
            </MyTypography>
            <MyTypography
              style={{
                whiteSpace: "pre-line"
              }}
              variant="body3"
            >
              {previewOrder?.previewDomesticOrder?.previewHeaderData?.shipTo}
            </MyTypography>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};
export default PreviewOrderNotRefHeader;
